module.exports = __webpack_public_path__ + "img/YOMI-MARCHIO.5b9949d2.png";